import { useGlobalContext } from "@/context/GlobalProvider";

export const useDialect = () => {
  const {
    currentDialect,
    setCurrentDialect: _setCurrentDialect,
    availableDialects,
  } = useGlobalContext();

  const setCurrentDialect = (newDialect: string) => {
    const dialectObj = availableDialects.find(
      (_dialectObj) => _dialectObj.urlValue === newDialect,
    );
    if (dialectObj) _setCurrentDialect(dialectObj);
  };

  return { currentDialect, availableDialects, setCurrentDialect };
};
